import { getSalesApiClient } from "@/sales-tools/home-product/api/api";
import type { ScaleEntry } from "../types";

export interface DashboardResponse {
    churns: number;
    enrolls: number;
    surveys: number;
    sellPay: number;
    servePay: number;
    sellRate: number;
    serveRate: number;
    lastUpdated: string;
    payPeriodStart: string;
    servePayScale: ScaleEntry[];
    sellPayScale: ScaleEntry[];
    isMissingData: boolean;
}

export const getPayDashboard = async () => {
    const response = await getSalesApiClient().get("v2/pay-dashboard");
    const data: DashboardResponse = await response.json();
    data.isMissingData = response.status === 204;
    return data;
};
